import { connect } from 'react-redux';
import { createSelector } from 'reselect';
import {
	getBlockedAppsBannerStatePortal,
	getBlockedAppsBannerStateCreateRequest,
	getBlockedAppsBannerStateRequestView,
	getBlockedAppsBannerStateCsmRequestCreate,
} from 'state/selectors/blocked-apps-banner';
import { getAccountId } from 'state/selectors/user';
import BlockedAppsBannerComponent from 'view/blocked-apps-banner/blocked-apps-banner';
import withAnalyticsContext from '@atlaskit/analytics-next/withAnalyticsContext';

const blockedAppsBannerSelector = createSelector(
	getBlockedAppsBannerStatePortal,
	getBlockedAppsBannerStateRequestView,
	getBlockedAppsBannerStateCreateRequest,
	getBlockedAppsBannerStateCsmRequestCreate,
	getAccountId,
	(portal, viewRequest, createRequest, csmRequestCreate, accountId) => {
		return {
			accountId,
			blockedAppsBannerState: {
				portal,
				view_request: viewRequest,
				create_request: createRequest,
				csm_create_request: csmRequestCreate,
			},
		};
	},
);

export const BlockedAppsBanner = connect(blockedAppsBannerSelector)(
	withAnalyticsContext({ componentName: 'blockedAppBanner' })(BlockedAppsBannerComponent),
);
